import { Component, Input, OnInit, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { AssetUrlService } from 'src/app/services/basic/asset-url.service';

@Component({
    selector: 'app-smblockimage',
    templateUrl: './smblockimage.component.html',
    styleUrls: ['./smblockimage.component.scss'],
    standalone: false
})
  
export class SmblockimageComponent implements OnInit {
  @Input() b: any;
  public basepath = '';

  private assetUrl = inject(AssetUrlService);

  constructor(
    public data: DataService
  ) {
  }

  ionViewWillEnter() {
    console.log(' will this.data.basePath');
    console.log(this.data.basePath);
    this.basepath = this.assetUrl.getMediaBase();
  }

  ngOnInit() {
    console.log(' init this.data.basePath');
    console.log(this.data.basePath);
    this.basepath = this.assetUrl.getMediaBase();
  }
  
  safeURL(item) {
    return encodeURI(item);
  }

  mediaUrl(path: string): string {
    return this.assetUrl.mediaUrl(path);
  }
}
